import EnglishSentences from "../assets/Vocab/EnglishSentences.json";
import ChineseSentences from "../assets/Vocab/ChineseSentences.json";

const ENGLISH_SENTENCES = EnglishSentences;
const CHINESE_SENTENCES = ChineseSentences;

export { ENGLISH_SENTENCES, CHINESE_SENTENCES };
